import { BaseWebComponentDataProvider } from '../../framework/BaseWebComponentDataProvider';

export class AlertsAppBaseDataProvider extends BaseWebComponentDataProvider {}
